var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCherry = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31598_96206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.17188 7.91016C8.38003 7.91016 9.44419 7.58036 10.323 7.15952C9.4308 8.83816 8.89625 10.7813 8.79016 12.7852C5.22297 13.1681 2.42578 16.1608 2.42578 19.8281C2.42578 23.7537 5.6193 27 9.54492 27C10.7543 27 11.9128 26.6593 12.9519 26.0893C11.34 24.5091 10.3359 22.2584 10.3359 19.8281C10.3359 17.3978 11.34 15.1999 12.9519 13.6197C12.1518 13.1807 11.28 12.8822 10.3697 12.7663C10.7137 7.17517 14.9362 2.56339 20.3804 1.7219C18.9939 3.66854 18.2461 5.99133 18.2461 8.43008V12.7889C14.6962 13.1883 11.918 16.1732 11.918 19.8281C11.918 23.7537 15.1115 27 19.0371 27C22.9627 27 26.1562 23.7537 26.1562 19.8281C26.1562 16.1732 23.378 13.1883 19.8281 12.7889V8.43008C19.8281 5.75567 20.8694 3.24131 22.7604 1.35029L24.1107 0H22.2012C18.4859 0 15.1187 1.51508 12.6824 3.95899C12.0428 3.34492 9.99193 1.58203 7.17188 1.58203C3.83478 1.58203 1.55134 4.06858 1.44093 4.17446L0.84375 4.74609L1.44093 5.31773C1.55134 5.42361 3.83478 7.91016 7.17188 7.91016ZM19.0371 17.4551C17.7286 17.4551 16.6641 18.5197 16.6641 19.8281H15.082C15.082 17.6475 16.8565 15.873 19.0371 15.873V17.4551ZM9.54492 17.4551C8.23645 17.4551 7.17188 18.5197 7.17188 19.8281H5.58984C5.58984 17.6475 7.36427 15.873 9.54492 15.873V17.4551Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31598_96206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCherry);
export default ForwardRef;